import { Component } from '@angular/core';

@Component({
  selector: 'ag-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

}
